const KEY_AUTH_JWTTOKEN = 'gbAccessToken'
const KEY_AUTH_EXP = 'exp'
const KEY_AUTH_SUB = 'sub'
const KEY_AUTH_EMAIL = 'email'
const KEY_AUTH_SESSION = 'session'
const KEY_AUTH_USENAME = 'username'
const KEY_AUTH_USENAME_KANA = 'usernamekana'

export default class LocalDataUtil {
  // setter
  static setSessionData (session) {
    localStorage.setItem(KEY_AUTH_JWTTOKEN, session.accessToken.jwtToken)
    localStorage.setItem(KEY_AUTH_EXP, session.accessToken.payload.exp)
    localStorage.setItem(KEY_AUTH_USENAME, session.idToken.payload.name)
    localStorage.setItem(KEY_AUTH_USENAME_KANA, session.idToken.payload.nickname)
  }
  static setSub (sub) {
    localStorage.setItem(KEY_AUTH_SUB, sub)
  }
  static setCcsSession (session) {
    localStorage.setItem(KEY_AUTH_SESSION, session)
  }

  // getter
  static getCcsSession () {
    return localStorage.getItem(KEY_AUTH_SESSION)
  }
  static getUserName () {
    return localStorage.getItem(KEY_AUTH_USENAME)
  }
  static getUserNameKana () {
    return localStorage.getItem(KEY_AUTH_USENAME_KANA)
  }
  static getJwtToken () {
    return localStorage.getItem(KEY_AUTH_JWTTOKEN)
  }
  static getExp () {
    return localStorage.getItem(KEY_AUTH_EXP)
  }
  static getSub () {
    return localStorage.getItem(KEY_AUTH_SUB)
  }
  static getEmail () {
    return localStorage.getItem(KEY_AUTH_EMAIL)
  }
  static getServerId () {
    const hostname = location.hostname
    const env = hostname.split('.')[0]
    if (env === 'local' || env === 'localhost' || env === 'qa1') {
      // QA・local環境
      return 'ccsp-staging'
    } else if (env === 'ccsapp') {
      // 本番環境
      return 'p001'
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/LocalDataUtil.js